import React, { useState, useEffect } from "react";
import { moneyFormat } from "../../ultil";
import TextTitle from "../Text/TextTitle";
import TextTitle1 from "../Text/TextTitle1";
import TextBody from "../Text/TextBody";
import TextBody2 from "../Text/TextBody2";
import TextHead from "../Text/TextHead";
import TextPrice from "../Text/TextPrice";
import TextPriceOld from "../Text/TextPriceOld";
import TextQuantity from "../Text/TextQuantity";
import TextOutOfStock from "../Text/TextOutOfStock";
import {
  Box,
  Divider,
  Button,
  ButtonBase,
  ButtonGroup,
} from '@mui/material';

const noFunc = () => {}

const billTopping = dataDetail => {
  let sum = dataDetail.pricePromote;
  if (dataDetail.toppingSelected) {
    dataDetail.toppingSelected.map((item, i) => {
      item.topping.map((t, j) => {
        sum += t.price * t.quantity;
      });
    });
  }
  return sum * dataDetail.quantity;
};

const renderNameTopping = data => {
  let toppings = [];
  data && data.map((item, i) => {
    item.toppingSelected &&
    item.toppingSelected.map((t, j) => {
      toppings.push(t.name);
    });
  });
  return toppings.join(", ");
};

const MenuItem = ({readOnly = false, lastItem = false, dataItem, quantity = 0, onClickAdd = noFunc, onClickMinus = noFunc, onClickItem = noFunc}) => {
  const {_id, images, isAvailable, status, name, price, pricePromote, topping} = dataItem
  const disable = !readOnly && !status, outOfStock = !readOnly && !isAvailable, showPrice = pricePromote, oldPrice = price === pricePromote ? null : price, toppings = renderNameTopping(dataItem.topping)
  return <>
  <Box mt={1} mb={1} sx={{cursor: 'pointer'}} onClick={onClickItem}>
    <Box sx={{width: '100%', display: 'flex'}}>
      <Box>
        <ButtonBase sx={{width: 96, height: 96, borderRadius: '16px', position: 'relative' }}>
          <img src={images[0]} width="100%" height="100%" style={{borderRadius: '16px', filter: disable ? 'grayscale(1)': ''}}/>
          {outOfStock && <TextOutOfStock>Hết hàng</TextOutOfStock>}
        </ButtonBase>
      </Box>
      <Box pl={2} sx={{flexGrow: 1, display: 'flex', flexDirection: 'column', justifyContent: 'space-between'}}>
        <TextBody className="line-clamp-2" gutterBottom>
          {readOnly &&
            <TextBody component="span">x{quantity}</TextBody>
          } {name}
        </TextBody>
        {
          toppings ?
          <TextBody className="line-clamp-1" color="#929394" gutterBottom>
            {toppings}
          </TextBody>
          :null
        }

        <Box sx={{display: 'flex', alignItems: 'end'}}>
          <Box sx={{flexGrow: 1, display: 'flex', flexWrap: 'wrap-reverse', alignItems: 'end'}}>
            {
              readOnly ?
              <TextPrice className="line-clamp-1" mr={1} component="div">
              {moneyFormat(billTopping(dataItem))}
              </TextPrice>
              :
              showPrice && <TextPrice className="line-clamp-1" mr={1} component="div" color={disable ? "#7F8182" : "#1589D8"}>
                {moneyFormat(showPrice)}
              </TextPrice>
            }
            {
              !readOnly && oldPrice && <TextPriceOld className="line-clamp-1" component="div" color="#929394">
                {moneyFormat(oldPrice)}
              </TextPriceOld>
            }
          </Box>
          <Box>
          {
            !readOnly &&
            <ButtonGroup size="large" sx={{justifyContent: 'space-between', alignItems: 'end'}} variant="text" aria-label="text button group">
              {
                quantity > 0?
                <>
                <ButtonBase disabled={disable} onClick={(e)=>{
                  e.stopPropagation()
                  onClickMinus()
                }}>
                  <i className="icon-minus-square" style={{fontSize: '26px', color: disable ? '#7F8182' : '#b0bec5'}}/>
                </ButtonBase>
                <ButtonBase sx={{minWidth: '30px'}}>
                  <TextQuantity component="p">{quantity}</TextQuantity>
                </ButtonBase>
                </>
                :null
              }
              <ButtonBase disabled={disable} onClick={(e)=>{
                e.stopPropagation()
                onClickAdd()
              }}><i className="icon-add-square" style={{fontSize: '26px', color: disable ? '#7F8182' : '#1589D8'}}/></ButtonBase>
            </ButtonGroup>
          }

          </Box>
        </Box>
      </Box>
    </Box>
  </Box>
  {!lastItem && <Divider/>}
  </>
}

export default MenuItem
